import mod from "-!./login.js?vue&type=script&lang=js&"; export default mod; export * from "-!./login.js?vue&type=script&lang=js&"